export function removeUndefinedProps(diffObj: any) {
	for (const key in diffObj) {
		if (
			Object.hasOwn(diffObj, key) &&
			(diffObj[key] === undefined ||
				(typeof diffObj[key] === 'object' && Object.keys(diffObj[key]).length === 0))
		) {
			delete diffObj[key];
		}
	}
}
